import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class BaseService {
  constructor(private httpClient: HttpClient) {}

  get baseUrl(): string {
    let url = environment.apiUrl || '';
    if (url && !url.endsWith('/')) {
      url += '/';
    }
    return url;
  }

  private buildUrl(path: string): string {
    const base = this.baseUrl;
    const cleanPath = path.startsWith('/') ? path.substring(1) : path;
    return `${base}${cleanPath}`;
  }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  get<T>(
    url: string,
    id?: number | boolean | string,
    params?: any,
    headers?: any
  ): Observable<T> {
    const fullUrl = (id !== null && id !== undefined)
      ? `${this.buildUrl(url)}/${id}`
      : this.buildUrl(url);

    return this.httpClient.get<T>(fullUrl, {
      headers: headers || this.httpOptions.headers,
      params,
    });
  }

  post<T>(url: string, data: any): Observable<T> {
    return this.httpClient.post<T>(this.buildUrl(url), data);
  }

  put<T>(url: string, data: any): Observable<T> {
    return this.httpClient.put<T>(this.buildUrl(url), data);
  }

  delete<T>(url: string, id: number | string): Observable<T> {
    return this.httpClient.delete<T>(`${this.buildUrl(url)}/${id}`);
  }

  patch<T>(url: string, data?: any): Observable<T> {
    return this.httpClient.patch<T>(this.buildUrl(url), data);
  }
}
